import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultUseCaseResource,
    UseCaseMutationResourceSchema,
    useUseCaseActions,
} from '../../../../../resource/resources/artifacts/use_case/useCaseResource';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { UseCaseContent } from './UseCaseContent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { Text } from '@mantine/core';

export const UseCaseView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const useCaseActions = useUseCaseActions()
    const useCaseQuery = useCaseActions.useGetResource(id);
    const updateUseCase = useCaseActions.useUpdateResource();
    const validateUseCase = useCaseActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: UseCaseMutationResourceSchema,
        defaultValues: defaultUseCaseResource,
        submitHandler: async (data) => {
            await updateUseCase.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: useCaseQuery.data,
    });

    return (
        <QueryBaseComponent name="UseCase" query={useCaseQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateUseCase.data}
                    metaDataInfo={useCaseQuery.data}
                    resourceType={ResourceType.USE_CASE}
                >
                    <Text c="dimmed">UseCase</Text>
                </ResourceValidationTitleBar>
                <UseCaseContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
